const s = {
  name: "Issuing",
  dimensions: { width: 40, height: 30 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 30" style="enable-background:new 0 0 40 30;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M4,10h5V8H4V10z"/>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v8c0,1.7,1.3,3,3,3h13c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z M2,3c0-0.6,0.4-1,1-1h13
			c0.6,0,1,0.4,1,1v1H2V3z M2,6h15v5c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V6z"/>
		<path class="st0" d="M34,10h2V8h-2V10z"/>
		<path class="st0" d="M32,10c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1s-1,0.4-1,1C31,9.6,31.4,10,32,10z"/>
		<path class="st0" d="M24,0c-1.7,0-3,1.3-3,3v8c0,1.7,1.3,3,3,3h13c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H24z M23,3c0-0.6,0.4-1,1-1
			h13c0.6,0,1,0.4,1,1v1H23V3z M23,6h15v5c0,0.6-0.4,1-1,1H24c-0.6,0-1-0.4-1-1V6z"/>
		<path class="st0" d="M6,26H4v-2h2V26z"/>
		<path class="st0" d="M9,25c0,0.6-0.4,1-1,1s-1-0.4-1-1c0-0.6,0.4-1,1-1S9,24.4,9,25z"/>
		<path class="st0" d="M0,19c0-1.7,1.3-3,3-3h13c1.7,0,3,1.3,3,3v8c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V19z M3,18c-0.6,0-1,0.4-1,1
			v1h15v-1c0-0.6-0.4-1-1-1H3z M2,27c0,0.6,0.4,1,1,1h13c0.6,0,1-0.4,1-1v-5H2V27z"/>
		<path class="st0" d="M36,26h-5v-2h5V26z"/>
		<path class="st0" d="M24,16c-1.7,0-3,1.3-3,3v8c0,1.7,1.3,3,3,3h13c1.7,0,3-1.3,3-3v-8c0-1.7-1.3-3-3-3H24z M23,19
			c0-0.6,0.4-1,1-1h13c0.6,0,1,0.4,1,1v1H23V19z M23,22h15v5c0,0.6-0.4,1-1,1H24c-0.6,0-1-0.4-1-1V22z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Issuing
};
